var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app"}},[_c('navigation-drawer'),_c('app-bar'),_vm._t("default"),_c('profile-menu'),_c('profile-button'),_c('contact-box'),_c('loading'),_c('product-version-badge')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }